import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../services/api';

const CajaContext = createContext();

export const CajaProvider = ({ children }) => {
    const [cajaActual, setCajaActual] = useState(null);
    const [cargando, setCargando] = useState(false);

    const cargarCajaActual = useCallback(async () => {
        setCargando(true);
        try {
            const res = await api.get('/cajas/actual');
            setCajaActual(res.data.data);
        } catch (error) {
            console.error('Error cargando caja:', error);
            setCajaActual(null);
        } finally {
            setCargando(false);
        }
    }, []);

    // Función para recalcular totales de ventas del día
    const recalcularVentasHoy = useCallback(async () => {
        try {
            const res = await api.get('/cajas/actual');
            if (res.data.data) {
                setCajaActual(prev => ({
                    ...prev,
                    ...res.data.data,
                    ventas_hoy: res.data.data.ventas_hoy
                }));
            }
        } catch (error) {
            console.error('Error recalculando ventas:', error);
        }
    }, []);

    return (
        <CajaContext.Provider value={{ 
            cajaActual, 
            cargando, 
            cargarCajaActual, 
            recalcularVentasHoy,
            setCajaActual 
        }}>
            {children}
        </CajaContext.Provider>
    );
};

export const useCaja = () => {
    const context = useContext(CajaContext);
    if (!context) {
        throw new Error('useCaja debe usarse dentro de CajaProvider');
    }
    return context;
};